/**
 * Stylized quote component for phase content
 */
"use client"

import { phasesData } from "@/lib/phases"
import React, { ReactNode } from "react"

type PhaseQuoteProps = {
  phaseId: string
  children: ReactNode
}

export function PhaseQuote({ phaseId, children }: PhaseQuoteProps) {
  // Find the phase data by ID
  const phase = phasesData.find(p => p.id === phaseId) || phasesData[0]

  // Derive color styles based on the phase color
  const colorStyles = {
    bg: `bg-${phase.color}-50/70 dark:bg-${phase.color}-950/40`,
    border: `border-${phase.color}-200/80 dark:border-${phase.color}-800/40`,
    text: `text-${phase.color}-800 dark:text-${phase.color}-200`,
    icon: `text-${phase.color}-600 dark:text-${phase.color}-400`,
  }

  return (
    <div
      className={`my-6 rounded-xl border p-5 ${colorStyles.bg} ${colorStyles.border}`}
    >
      <div className="flex items-start gap-3">
        <div className={`mt-1 text-2xl ${colorStyles.icon}`}>❝</div>
        <div className={`text-lg font-medium ${colorStyles.text}`}>
          {children}
        </div>
        <div className={`mt-1 text-2xl ${colorStyles.icon}`}>❞</div>
      </div>
    </div>
  )
}
